module.exports = __webpack_public_path__ + "insert-variable.9344cc9087b8f1add3408a7c745b4731.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/InsertVariableButton/insert-variable.svg
// module id = 1551
// module chunks = 8